<!-- Copyright (c) 2023 Cigent Technology Inc. All Rights Reserved. -->
<div style="text-align: center">
    <form [formGroup]="verifyCodeFormGroup" class="checkout-free-trial" #verifyCodeForm="ngForm" (ngSubmit)="onSubmitClick()">
        <div class="verify-email-header">{{'SUB_VERIFY_CODE' | translate}}</div>
        <div class="verify-email-header-sub">{{'SUB_VERIFY_CHECK' | translate}}</div>
        <div class="code-emailed-to">{{'SUB_VERIFY_SENT' | translate}} <strong>{{ this.address }}</strong></div>
        <div>
            <mat-form-field appearance="outline" class="free-trial-input">
                <mat-label>{{'SUB_VERIFICATION_CODE_LABEL' | translate}}</mat-label>
                <input data-lpignore="true" matInput name="hiddenFieldToStopBrowserAutofillVerify" placeholder="{{'SUB_VERIFY_ENTER' | translate}}" formControlName="verifyCode" required />
                <mat-error *ngIf="e.verifyCode.errors" class="invalid-feedback">
                    <div *ngIf="e.verifyCode.errors.required; else invalidCode">
                        {{'SUB_VERIFY_ERROR' | translate}}
                    </div>
                    <ng-template #invalidCode>
                        <div>
                            {{'SUB_VERIFY_INVALID' | translate}}
                        </div>
                    </ng-template>
                </mat-error>
            </mat-form-field>
        </div>
        <div>
            <span class="resend-wrapper" >
                <span class="resend-code-link">
                    <button mat-raised-button type="button" (click)="onResendClick()" style="margin-right: 2em">{{'SUB_VERIFY_RESEND' | translate}}</button>
                    <button mat-raised-button type="submit" color="primary" [disabled]="!verifyCodeFormGroup.valid || submitting">{{'SUB_CHECK_CODE' | translate}}</button>
                </span>
            </span>
        </div>
    </form>
</div>
